import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getOccupationList, getEducationList, addEditFamily, getOneFamily, getRelationList } from "../../Redux/Slices/userAnalyticsSlice";
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';
import moment from "moment";

const FamilyDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, memberId } = useParams();
  const [educations, setEducations] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [relations, setRelations] = useState([]);
  const [allData, setAllData] = useState([]);
  const [educationSearch, setEducationSearch] = useState("");
  const [occupationSearch, setOccupationSearch] = useState("");

  const menuPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const initialValues = {
    familyMemberId: "",
    userId: '',
    relation: '',
    surname: 'સવાણી',
    name: '',
    fathername: '',
    dob: '',
    age: '',
    education: '',
    is_married: '',
    business: ''
  };
  const [formValues, setFormValues] = useState(initialValues);

  const fetchFamilyData = async () => {
    if (memberId) {
      const payload = { familyMemberId: memberId };
      try {
        const res = await dispatch(getOneFamily(payload)).unwrap();
        if (res.IsSuccess) {
          setAllData(res?.Data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const validationSchema = Yup.object({
    relation: Yup.string().required('Relation is Required'),
    surname: Yup.string().required('Surname is Required'),
    name: Yup.string().required('Name is Required'),
    fathername: Yup.string().required('Fathername is  Required'),
    dob: Yup.string(),
    age: Yup.string().required('Age is Required'),
    is_married: Yup.string().required('Select any one option.'),
  });

  const getEducation = async (search = "") => {
    try {
      const response = await dispatch(getEducationList({ search })).unwrap();
      if (response.IsSuccess) {
        setEducations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Education");
    }
  };

  const getOccupation = async (search = "") => {
    try {
      const response = await dispatch(getOccupationList({ search })).unwrap();
      if (response.IsSuccess) {
        setOccupations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Business");
    }
  };

  const getRelation = async () => {
    try {
      const response = await dispatch(getRelationList()).unwrap();
      if (response.IsSuccess) {
        setRelations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Relation");
    }
  };

  const handleSubmit = async (values) => {
    if (!values) {
      console.error("Values are null or undefined!");
      toast.error("Form data is missing.");
      return;
    }
    const payload = {
      ...values,
      familyMemberId: memberId || "",
      userId: id || "",
      relation: values?.relation || "",
      surname: values?.surname || "",
      name: values?.name || "",
      fathername: values?.fathername || "",
      dob: values.dob ? moment(values.dob).format("DD/MM/YYYY") : "",
      age: Number(values?.age) || "",
      // is_youngtarang: values?.is_youngtarang || "",
      education: values?.education || "",
      is_married: values?.is_married || false,
      business: values?.business || "",
      address: values?.address || "",
    };
    try {
      const response = await dispatch(addEditFamily(payload)).unwrap();
      if (response.IsSuccess) {
        toast.success(response.Message);
        navigate(`/edit-family-list/${id}`);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form: ", error);
      toast.error("Failed to save family member.");
    }
  };


  const handleGujaratiChange = (e, setFieldValue) => {
    const { name, value } = e.target;

    const gujaratiOnly = /^[\u0A80-\u0AFF\d\s]*$/;

    if (value === "" || gujaratiOnly.test(value)) {
      setFieldValue(name, value);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFamilyData();
    }
    getRelation();
  }, [id]);

  useEffect(() => {
    const timer = setTimeout(() => getEducation(educationSearch), 500);
    return () => clearTimeout(timer);
  }, [educationSearch]);

  useEffect(() => {
    const timer = setTimeout(() => getOccupation(occupationSearch), 500);
    return () => clearTimeout(timer);
  }, [occupationSearch]);

  useEffect(() => {
    if (memberId && allData) {
      setFormValues({
        familyMemberId: allData?._id || "",
        userId: allData?.userId || "",
        relation: allData?.relation?._id || "",
        surname: allData?.surname || "સવાણી",
        name: allData?.name || "",
        fathername: allData?.fathername || "",
        dob: moment(allData.dob, "DD/MM/YYYY").format("YYYY-MM-DD"),
        age: allData?.age || "",
        // is_youngtarang: allData?.is_youngtarang || "",
        education: allData?.education?._id || "",
        is_married: allData?.is_married || false,
        business: allData?.business?._id || "",
        address: allData?.address || "",
      });
    } else {
      setFormValues({
        ...initialValues,
        surname: 'સવાણી'
      });
    }
  }, [allData, memberId]);

  return (
    <>
      <div className="mx-auto h-screen bg-white rounded-lg shadow-sm p-4">
        <Formik
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ isSubmitting, setFieldValue, values, errors, touched }) => (
            <Form className="w-full p-6 pb-0">
              <div className="flex justify-between items-center mb-6">
                <Link to={`/edit-family-list/${id}`} className="text-teax_1 flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                  </svg>
                  Back
                </Link>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn"
                // onClick={handleSubmit}
                >
                  {isSubmitting ? "Submitting..." : "Save"}
                </button>
              </div>
              <h1 className='text-2xl font-bold pb-4'>કૌટુમ્બિક વિગતો</h1>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    કૌટુમ્બિક સંબંધ<span className='text-red text-18'>*</span>
                  </label>
                  {/* <Field
                      name="relation"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder='કૌટુમ્બિક સંબંધ'
                    /> */}
                  <Field
                    as="select"
                    id="relation"
                    name="relation"
                    className="w-full p-2.5 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled > Select Relation </option>
                    {relations.map((item) => (
                      <option key={item?._id} value={item?._id}>
                        {item?.gujarati_name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="relation" component="div" className="text-red text-sm mt-1" />
                </div>

                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    સભ્યની અટક<span className='text-red text-18'>*</span>
                  </label>
                  <Field
                    name="surname"
                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14 bg-gray-100 focus:outline-none"
                    placeholder='સભ્યની અટક'
                  />
                  <ErrorMessage name="surname" component="div" className="text-red text-sm mt-1" />
                </div>

                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    સભ્યનું નામ<span className='text-red text-18'>*</span>
                  </label>
                  <Field
                    name="name"
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder='સભ્યનું નામ'
                    onChange={(e) => handleGujaratiChange(e, setFieldValue)}
                  />
                  <ErrorMessage name="name" component="div" className="text-red text-sm mt-1" />
                </div>
                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {(() => {
                      const selectedRelation = relations.find((r) => r._id === values.relation);
                      return selectedRelation?.gujarati_name === "પત્ની" || selectedRelation?.gujarati_name === "માતા"
                        ? "સભ્યના પતિનું નામ"
                        : "સભ્યના પિતાનું નામ";
                    })()}<span className='text-red text-18'>*</span>
                  </label>
                  <Field
                    name="fathername"
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder={(() => {
                      const selectedRelation = relations.find((r) => r._id === values.relation);
                      return selectedRelation?.gujarati_name === "પત્ની" || selectedRelation?.gujarati_name === "માતા"
                        ? "સભ્યના પતિનું નામ"
                        : "સભ્યના પિતાનું નામ";
                    })()}
                    onChange={(e) => handleGujaratiChange(e, setFieldValue)}
                  />
                  {errors.fathername && touched.fathername && (
                    <div className="text-red text-sm mt-1">
                      {(() => {
                        const selectedRelation = relations.find((r) => r._id === values.relation);
                        return selectedRelation?.gujarati_name === "પત્ની" || selectedRelation?.gujarati_name === "માતા"
                          ? "Husband Name Required"
                          : "Father Name Required";
                      })()}
                    </div>
                  )}
                </div>

                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    જન્મ તારીખ
                  </label>
                  <Field
                    type="date"
                    name="dob"
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder='જન્મ તારીખ'
                    onChange={(e) => {
                      const dob = e.target.value;
                      setFieldValue("dob", dob);

                      // Calculate age when date of birth changes
                      if (dob) {
                        const birthDate = new Date(dob);
                        const currentYear = new Date().getFullYear();
                        const birthYear = birthDate.getFullYear();
                        const calculatedAge = currentYear - birthYear;

                        setFieldValue("age", calculatedAge);
                      }
                    }}
                  />
                  <ErrorMessage name="dob" component="div" className="text-red text-sm mt-1" />
                </div>

                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ઉંમર
                  </label>
                  <Field
                    type="text"
                    name="age"
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none bg-slate-100"
                    placeholder='ઉંમર'
                    readOnly
                  />
                </div>

                {/* <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    યંગ તરંગના સભ્યો છો કે નહીં?
                  </label>
                  <Field
                    as="select"
                    name="is_youngtarang"
                    className="w-full p-2.5 border border-gray-300 rounded-md"
                    placeholder='યંગ તરંગના સભ્યો છો કે નહીં?'
                  >
                    <option value="" selected>હા/ના</option>
                    <option value="true">હા</option>
                    <option value="false">ના</option>
                  </Field>
                </div> */}

                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    અભ્યાસ
                  </label>
                  <Select
                    id="education"
                    name="education"
                    filterOption={() => true}
                    inputValue={educationSearch}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") setEducationSearch(inputValue);
                    }}
                    onBlur={() => setEducationSearch("")}
                    options={educations.map((item) => ({
                      value: item?._id,
                      label: item?.gujarati_name,
                    }))}
                    value={
                      educations
                        .filter((e) => e._id === values.education)
                        .map((item) => ({
                          value: item?._id,
                          label: item?.gujarati_name,
                        }))[0] || null
                    }
                    onChange={(selected) => {
                      setEducationSearch("");
                      setFieldValue("education", selected ? selected.value : "");
                    }}
                    placeholder="Select Education"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={menuPortalStyles}
                    isClearable
                  />
                </div>
                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ધંધો - વ્યવસાય
                  </label>
                  <Select
                    id="business"
                    name="business"
                    filterOption={() => true}
                    inputValue={occupationSearch}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") setOccupationSearch(inputValue);
                    }}
                    onBlur={() => setOccupationSearch("")}
                    options={occupations.map((item) => ({
                      value: item?._id,
                      label: item?.gujarati_name,
                    }))}
                    value={
                      occupations
                        .filter((o) => o._id === values.business)
                        .map((item) => ({
                          value: item?._id,
                          label: item?.gujarati_name,
                        }))[0] || null
                    }
                    onChange={(selected) => {
                      setOccupationSearch("");
                      setFieldValue("business", selected ? selected.value : "");
                    }}
                    placeholder="Select Business"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={menuPortalStyles}
                    isClearable
                  />
                </div>
                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    તમે પરિણીત છો કે નહીં?<span className='text-red text-18'>*</span>
                  </label>
                  <Field
                    as="select"
                    name="is_married"
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder='વિવાહિત સ્થિતિ'
                  >
                    <option value="">વિવાહિત સ્થિતિ?</option>
                    <option value="true">પરિણીત</option>
                    <option value="false">અપરિણીત</option>
                  </Field>
                  <ErrorMessage name="is_married" component="div" className="text-red text-sm mt-1" />
                </div>

                <div className="w-full md:w-1/3 px-3 mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ધંધો - વ્યવસાયનું સરનામું
                  </label>
                  <Field
                    name="address"
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder='ધંધો - વ્યવસાયનું સરનામું'
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}

export default FamilyDetail;
